<div class="truncate leading-5 text-subtitle flex gap-2 items-center" translate>
  @if (item().metadata.date_end) {
    <div class="flex gap-2 items-center" [ngClass]="isWarning(item())">
      <svg-icon class="flex h-4 w-4" [src]="'icon-calendar' | icon"></svg-icon>
      {{ 'eclass.prazo' | translate }} <span>{{ item().metadata.date_end | date: 'dd/MM' }}</span>
    </div>
    @if (data() | noEmpty) {
      <svg-icon class="flex h-1 w-1 text-subtitle" src="assets/icons/icon-ellipse.svg"></svg-icon>
    }
  }

  @if (isEmployee()) {
    <svg-icon class="flex h-3 w-3 text-subtitle" [src]="'icon-user-3' | icon"></svg-icon>
    <span class="text-title">
      {{ 'eclass.respostas-envio' | translate }} {{ item().user_concludeds_count }}/{{ item().metadata.total }}
    </span>
    @if (data() | noEmpty) {
      <svg-icon class="flex h-1 w-1 text-subtitle" [src]="'icon-ellipse' | icon"></svg-icon>
    }
  }

  @for (label of data(); track $index) {
    {{ label }}
    @if (!$last) {
      <svg-icon class="flex h-1 w-1 text-subtitle" src="assets/icons/icon-ellipse.svg"></svg-icon>
    }
  }
</div>
